exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subject-text[data-v-45a761d9] {\n  width: auto;\n  word-break: break-word;\n  overflow: hidden;\n  padding-right: 16px;\n}\n.subject-text[data-v-45a761d9]:first-letter {\n  text-transform: uppercase;\n}", ""]);

// exports
